import { getFirestore } from "firebase/firestore";
import { initializeApp } from "firebase/app";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDM16kAV1uGzTdTM1mOsBMyl097rpqcvC4",
    authDomain: "cnr-beta-a3adb.firebaseapp.com",
    projectId: "cnr-beta-a3adb",
    storageBucket: "cnr-beta-a3adb.appspot.com",
    messagingSenderId: "753884133981",
    appId: "1:753884133981:web:d7d7e3ce7c71906cc66bb4"
};

// Initialize Firebase

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
